import { authApiService } from '../../authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export type AdminCompleteRegistrationPayloadType = {
  agree_with_condition: boolean;
  mobile_phone: string;
};

export const adminCompleteRegistrationApi = async (
  data: AdminCompleteRegistrationPayloadType
): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = '/users/auth/signup-complete-registration/';

  return authApiService.POST(uri, data);
};
